import React, { useEffect, useState } from "react";
import { createQuestion, updateQuestion } from "./quiz3Utils";

const emptyOptions = () => [
  { id: "a", text: "" },
  { id: "b", text: "" },
  { id: "c", text: "" },
  { id: "d", text: "" },
];

// QA-02 / QA-03 — tạo câu hỏi mới (hoặc QA-05 — sửa câu hỏi đã có nếu
// truyền `existing`). subjectId/topicId lấy từ node đang chọn ở cây.
const Quiz3QuestionForm = ({ uid, subjectId, topicId, existing, onDone, onCancel }) => {
  const [content, setContent] = useState(existing?.content || "");
  const [options, setOptions] = useState(existing?.options || emptyOptions());
  const [correctOptionId, setCorrectOptionId] = useState(existing?.correctOptionId || "a");
  const [explanation, setExplanation] = useState(existing?.explanation || "");
  const [difficulty, setDifficulty] = useState(existing?.difficulty || "medium");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (existing) {
      setContent(existing.content || "");
      setOptions(existing.options || emptyOptions());
      setCorrectOptionId(existing.correctOptionId || "a");
      setExplanation(existing.explanation || "");
      setDifficulty(existing.difficulty || "medium");
    }
  }, [existing]);

  const updateOptionText = (id, text) => {
    setOptions((opts) => opts.map((o) => (o.id === id ? { ...o, text } : o)));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!content.trim()) {
      setError("Vui lòng nhập nội dung câu hỏi.");
      return;
    }
    if (options.some((o) => !o.text.trim())) {
      setError("Vui lòng nhập đủ nội dung cho tất cả phương án trả lời.");
      return;
    }
    setSaving(true);
    try {
      const data = {
        subjectId,
        topicId: topicId || null,
        content: content.trim(),
        options,
        correctOptionId,
        explanation: explanation.trim() || null,
        difficulty,
      };
      if (existing) {
        await updateQuestion(existing.id, data);
      } else {
        await createQuestion(data, uid);
      }
      onDone && onDone();
    } catch (err) {
      setError(err.message || "Có lỗi xảy ra, thử lại.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} style={cardStyle}>
      <h3 style={{ marginTop: 0 }}>{existing ? "Sửa câu hỏi" : "Tạo câu hỏi mới"}</h3>

      <label style={labelStyle}>Nội dung câu hỏi</label>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        rows={3}
        style={textareaStyle}
        placeholder="Nhập nội dung câu hỏi..."
      />

      <label style={labelStyle}>Các phương án trả lời (chọn đáp án đúng)</label>
      {options.map((opt) => (
        <div key={opt.id} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
          <input
            type="radio"
            name="correctOption"
            checked={correctOptionId === opt.id}
            onChange={() => setCorrectOptionId(opt.id)}
          />
          <input
            type="text"
            value={opt.text}
            onChange={(e) => updateOptionText(opt.id, e.target.value)}
            style={{ ...inputStyle, flex: 1 }}
            placeholder={`Phương án ${opt.id.toUpperCase()}`}
          />
        </div>
      ))}

      <label style={labelStyle}>Giải thích đáp án (tùy chọn)</label>
      <textarea
        value={explanation}
        onChange={(e) => setExplanation(e.target.value)}
        rows={2}
        style={textareaStyle}
        placeholder="Vì sao đáp án này đúng..."
      />

      <label style={labelStyle}>Độ khó</label>
      <select value={difficulty} onChange={(e) => setDifficulty(e.target.value)} style={inputStyle}>
        <option value="easy">Dễ</option>
        <option value="medium">Trung bình</option>
        <option value="hard">Khó</option>
      </select>

      {error && <p style={{ color: "#dc2626", fontSize: 13 }}>{error}</p>}

      <div style={{ display: "flex", gap: 8, marginTop: 16 }}>
        <button type="submit" disabled={saving} style={primaryBtnStyle}>
          {saving ? "Đang lưu..." : existing ? "Lưu thay đổi" : "Tạo câu hỏi"}
        </button>
        {onCancel && (
          <button type="button" onClick={onCancel} style={secondaryBtnStyle}>
            Hủy
          </button>
        )}
      </div>
    </form>
  );
};

const cardStyle = {
  border: "1px solid #e5e7eb",
  borderRadius: 12,
  padding: 16,
  background: "#fff",
  maxWidth: 560,
};

const labelStyle = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  color: "#374151",
  margin: "12px 0 4px",
};

const inputStyle = {
  width: "100%",
  padding: "8px 10px",
  border: "1px solid #d1d5db",
  borderRadius: 8,
  fontSize: 14,
  boxSizing: "border-box",
};

const textareaStyle = { ...inputStyle, resize: "vertical" };

const primaryBtnStyle = {
  padding: "8px 16px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600,
};

const secondaryBtnStyle = {
  padding: "8px 16px",
  background: "#fff",
  color: "#374151",
  border: "1px solid #d1d5db",
  borderRadius: 8,
  cursor: "pointer",
};

export default Quiz3QuestionForm;
